import styled from "styled-components";
import { BsArrowDown, BsChevronDown } from "react-icons/bs";
import backgroundImage from "../../assets/ademars/3_website_push/Rock_Background.png";
import theme from "../../modules/themes";
export const Wrapper = styled.section`
  min-height: ${window.innerHeight}px;
  background-color: black
`;

export const ImageWrapper = styled.section`
  height: ${window.innerHeight}px;
  background-image: url(${backgroundImage});
  background-size: cover;
  background-position: center;
  position: relative;
`;

export const Container = styled.div`
  width: 100%;
  margin: auto;
`;


export const Fall = styled.section`
  min-height: ${window.innerHeight/2}px;
  width:100%;
  background-color:black;
  position:relative;

  .fall-house-image{
    width: 100%;
  }

  .explore-button{
    width:70%;
    margin: 0 auto 4.9rem auto;
    display:block;
    height: 3.5rem;
    background-color:white;
    color:black;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    color: black;
    padding-top:.1rem;
    font-family: helvetica-neue-light;
    @media(max-width:450px){
      font-size: 1.1rem;
      margin: 0 auto 2.9rem auto;
      height: 3.5rem;
    }
    @media(max-width:350px){
      margin-top:2rem
    }
  }

  .first-book-image-container{
    margin: 5.5rem auto 6rem auto;
    @media(max-width:450px){
      margin: 4.5rem auto 5rem auto;
    }
  }
  .first-book-image{
    width: 47%;
    margin: auto;
    display:block;
  }

  .fall-image-container{
    width:90%;
    margin .3rem auto
  }

  .fall-container{
    width:88%;
    margin: auto;

    &.second{
      padding-top: 1.5rem;

      @media(max-width: 450px){
        padding-top: 0rem;
        padding-bottom: 2rem;
      }

      @media(min-width: 768px){
        padding-top: 0.8rem;
      }
    }
  }

  .fall-white-section{
    margin: auto;
    background-color: white;

    .white-container{
      width: 85%;
      margin:auto;
      padding-top: 8rem;
      padding-bottom: 1.5rem;


      .subscribe-button{
        width:100%;
        display:block;
        height: 6.3rem;
        background-color:black;
        color:white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.8rem;
        padding-top:.1rem;
        font-family: helvetica-neue-light;
        @media(max-width:450px){
          font-size: 1.6rem;
          height: 5.3rem;
        }
        @media(max-width:350px){
          margin-top:2rem
        }
      }

      @media(max-width:450px){
        // padding-top: 11rem;
        // padding-bottom: 8rem;
      }
      @media(max-width:350px){
        // padding-top: 8rem;
        // padding-bottom: 6rem;
      }

      @media(min-width:786px){
        padding-bottom: 0.1rem;
      }
    }
  }

  .player-container{
    margin: 2rem 0 4.5rem 0;
    background-color: black;
    width:100%;
    height: 22rem;
  }

  .para-one{
    margin: 3rem auto 4rem auto;
    color: white;
    font-size:18px;
    line-height:1.3;

    &.two{
      line-height:1.45;
    }
    .first, .second, .third {
      display: block
    }

    @media(max-width:480px){
      .first, .second, .third {
        display: inline
      }
    }

    @media(max-width:450px){
      margin: 2.5rem auto 4rem auto;
      .first, .second, .third {
        display: block
      }
      font-size:14.5px;
    }

    @media(max-width:355px){
      margin: 2rem auto 3rem auto;
      font-size:12px;
      .first, .second, .third {
        display: inline
      }
    }
  }

  .para-two{
    margin: 2.4rem auto 5.1rem auto;
    color: white;
    font-size:17px;
    line-height:1.7;

    .first, .second, .third {
      display: block
    }

    @media(max-width:480px){
      .first, .second, .third {
        display: inline
      }
    }

    @media(max-width:450px){
      margin: 2rem auto 5.1rem auto;
      .first, .second, .third {
        display: block
      }
      width: 95%;
      font-size:15.5px;
      line-height:1.6;
    }

    @media(max-width:355px){
      margin: 0.8rem auto 0 auto;
      .first, .second, .third {
        display: inline
      }
      font-size:12px;
      line-height:1.5;
    }
  }
`

export const SecondaryTitle = styled.h1`
  font-family: helvetica-neue-extra-light;
  margin: 0 auto;
  font-size: 45px;
  color: #ffffff;
  text-transform: uppercase;
  padding:0;
  line-height:1;
  font-weight:200;

  @media(max-width:460px){
    font-size: 32px;
  }

  @media(max-width:375px){
    font-size: 28px;
  }

  @media(max-width:330px){
    font-size: 26px;
  }
  
`;

export const Title = styled.h1`
  width: 75%;
  font-family: walbaumBook-medium;
  margin: auto;
  font-size: 40px;
  color: #ffe4cb;
  padding-top: 45px;

  @media(max-width:430px){
    font-size: 32px;
    padding-top: 35px;
  }

  @media(max-width:350px){
    font-size: 28px;
    padding-top: 35px;
  }

`;
export const Horizontal = styled.div`
  width: 75px;
  height: 1px ;
  background-color: rgb(216, 122, 62);
  margin-top: 10px;

  @media(max-width:430px){
    width: 60px;
    margin-top: 8px;
  }
  @media(max-width:350px){
    width: 55px;
  }
`;
export const ScrollIndicatorSection = styled.section`
  position: absolute;
  width: 100%;
  bottom: 1.5rem;
  left: 0;
  text-align: center;
  `;
  
  export const ScrollIndicatorText = styled.div`
  font-size: 14px;
  font-weight:600;
  color: white;

  @media(max-width:430px){
    font-size: 10px;
  }

`;

export const ScrollIndicatorIcon = styled(BsChevronDown)`
  margin-top: 0.3rem;
  color: white;

  @media(max-width:430px){
    margin-right:0
  }
`;

export const ArticleContainer = styled.section`
  width:100%;
  margin:auto;
  background-color: black
`;

export const Article = styled.article`
  display:flex;
  flex-direction:column;
  min-height:200px;
  padding: 0 0 70px 0;
  justify-content:space-between;
  position:relative;
  
  div{
    width:100%;
    .buttons-container{
      width:100%;
      display:flex;
      align-items:center;
      justify-content:space-evenly;
    }
    a{
      width:45%
    }
    button{
      width:100%;
      background-color:${theme.primaryBlue};
      font-family: walbaumBook-medium;
      color:white;
      padding:12px 0;
      outline:0;
      border-color:transparent;
      border-radius:0;
      box-shadow:0;
      margin:30px 0 0  0;
      font-size:9px;
    }
  }
  img{
    width:100%;
  }
  div:nth-child(2){
    width:85%;
    margin:auto;
    text-align:left;

    h2{
      color:#D87A3E;
      margin-top:25px;
      font-family: walbaumBook-medium;
      }
    p:nth-child(2){
      font-size:13px;
      margin-top:5px;
      color:#D87A3E;
      font-family: walbaumBook-medium;

    }
    p:nth-child(3){
      font-size:12px;
      margin-top:10px;
      font-weight:200;
      color:#5D3D31
    }
    p:nth-child(4){
      font-size:12px;
      margin-top:20px;
      font-weight:200;
      color:#5D3D31
    }
    
  }

  @media(max-width:350px){
    div{
      .buttons-container{
        flex-direction:column
      }
      a{
        width:60%
      }
      button{
        margin:30px 0 0 0;
        font-size:10px
      }
    }
  }
`;
